function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#272848",
  d: "M4121.4,4966.7c-790.7-146.2-1564.1-500.2-2193.2-1006.2C-313.2,2154-524.8-1178.2,1466.4-3250.2C2226.3-4041,3199.8-4545,4288.7-4710.5c286.7-44.2,844.6-57.7,1146.7-30.8c1531.4,140.4,2891.6,977.3,3728.5,2291.3c121.2,188.5,355.9,671.4,444.4,911.9c279,756.1,363.6,1664.2,229,2474.1C9498.6,2985.1,7896,4608.9,5858.6,4968.6C5647,5005.2,4327.2,5003.2,4121.4,4966.7z M6649.4,1778.8C7551.6,876.5,8290.4,130,8290.4,118.5c0-9.6-123.1-142.4-273.2-292.4l-275.1-275.1L6372.3,920.8L5000.6,2292.5L3628.8,920.8L2259-449.1l-275.1,275.1c-150.1,150.1-273.2,282.8-273.2,292.4c0,19.2,3270.6,3299.5,3289.9,3299.5C5006.3,3418,5749,2679.2,6649.4,1778.8z M7193.8,2413.7l-1.9-794.6l-157.8,165.5c-86.6,90.4-311.7,329-498.3,531L6193.4,2683v261.6v261.7h500.2h500.2V2413.7z M6468.5,466.7L7578.6-628V-1865v-1239l-850.4,3.9l-852.3,5.8l-5.8,1092.8l-3.8,1090.8h-856.1h-856.1v-1096.6V-3104h-865.8h-865.8v1246.7v1244.8l1285.2,1264L4991,1913.5l182.8-177C5273.8,1638.4,5856.7,1067,6468.5,466.7z"
})));

function SvgWww(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWww);
export default __webpack_public_path__ + "static/media/www.34b47670.svg";
export { ForwardRef as ReactComponent };